import { EventType, EventTypeSchema, VersionedTemplateStatusValues } from '../types';
import { medtechApi } from './index';

const eventTypesApi = {
  async getAllEventTypes(company: number, status: VersionedTemplateStatusValues): Promise<EventType[] | undefined> {
    const statuses = status === 'allActive' ? ['draft', 'effective'] : [status];
    const options = { params: { statuses: statuses }, paramsSerializer: { indexes: null } };
    const res = await medtechApi.get(`/v2/${company}/workflows`, options);

    return EventTypeSchema.array().parse(res.data);
  },

  async getEventTemplates(company: number): Promise<EventType[] | undefined> {
    const res = await medtechApi.get(`/companies/${company}/event-templates`);

    return EventTypeSchema.array().parse(res.data);
  },
};

export default eventTypesApi;
